import { all } from "redux-saga/effects";
import { feedBackPageSaga } from "./sagas/feedBackPageSaga";
import { giftExchangePageSaga } from "./sagas/giftExchangePageSaga";
import { homePageSaga } from "./sagas/homePageSaga";
import { infoLoyaltyPageSaga } from "./sagas/infoLoyaltyPageSaga";
import { infomationStorePageSaga } from "./sagas/infomationStorePageSaga";
import { loginPageSaga } from "./sagas/loginPageSaga";
import { notificationPageSaga } from "./sagas/notificationPageSaga";
import { orderPageSaga } from "./sagas/orderPageSaga";
import { signaturePageSaga } from "./sagas/signaturePageSaga";
import { specialOfferPageSaga } from "./sagas/specialOfferPageSaga";
import { gamePageSaga } from "./sagas/gameSaga";

export default function* rootSaga() {
	yield all([
		feedBackPageSaga(),
		giftExchangePageSaga(),
		homePageSaga(),
		infoLoyaltyPageSaga(),
		orderPageSaga(),
		loginPageSaga(),
		specialOfferPageSaga(),
		infomationStorePageSaga(),
		signaturePageSaga(),
		notificationPageSaga(),
		gamePageSaga()
	]);
}
